import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import HubSpotContactList from "./HubSpotContactList";
import { ModalPickerProps } from "../props";

const HubSpotContactModalPicker = (props: ModalPickerProps<server.dto.HubSpotContact>) => {

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={"Link with HubSpot contact"}
    modalTitle={"HubSpot contacts"}
    modalSize="mini"
    renderModalContent={(closeModal) => <HubSpotContactList
      onItemSelected={(contact) => {
        closeModal();
        props.onChange(contact);
      }}
    />}
    renderRemovable={() => <></>}

    {...props}
  />;
};

export default HubSpotContactModalPicker;